import { supabase } from '@/services/supabaseClient';
import type { TipoFrete } from '@/utils/frete';

// Grava o frete manual no cadastro do cliente (Edge Function zsb-cliente-frete).
// Retorna null em caso de sucesso ou a mensagem de erro.
export async function saveClienteFrete(codigo: string, frete: TipoFrete | null): Promise<string | null> {
  if (!supabase) return 'Supabase não configurado.';
  const { data: sessionData } = await supabase.auth.getSession();
  const token = sessionData.session?.access_token;
  if (!token) return 'sessão expirada.';
  try {
    const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/zsb-cliente-frete`, {
      method: 'POST',
      headers: { apikey: import.meta.env.VITE_SUPABASE_ANON_KEY, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ codigo, frete }),
    });
    const payload = await response.json().catch(() => ({}));
    return response.ok ? null : payload.error || 'não foi possível salvar.';
  } catch {
    return 'serviço indisponível.';
  }
}
